var _path, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIcDeliveryConfirmation(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12 23C5.92487 23 1 18.0751 1 12 1 5.92487 5.92487 1 12 1 18.0751 1 23 5.92487 23 12 23 18.0751 18.0751 23 12 23zm0-2C16.9706 21 21 16.9706 21 12 21 7.02944 16.9706 3 12 3 7.02944 3 3 7.02944 3 12 3 16.9706 7.02944 21 12 21zM15.2929 8.29289 10 13.5858 7.70711 11.2929 6.29289 12.7071 10 16.4142 16.7071 9.70711 15.2929 8.29289z",
    fill: "url(#paint0_linear_7465_16669)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_7465_16669",
    x1: -11.65,
    y1: 0.53967,
    x2: -11.65,
    y2: 19.1447,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0095ff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#016dff"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcDeliveryConfirmation);
export default __webpack_public_path__ + "static/media/ic-delivery-confirmation.7da6c64c.svg";
export { ForwardRef as ReactComponent };